import styled from 'styled-components';

import { Badge } from 'components';

export const Wrapper = styled.li<{
  active: boolean;
  isToggle: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  height: 38px;
  ${p => p.isToggle && ``}
  justify-content: ${p => (p.isToggle ? 'flex-start' : 'center')};
  padding-left: ${p => (p.isToggle ? '12px' : '0px')};
  color: ${props => (props.active ? props.theme.colors.primary.main : null)};
  background: ${props =>
    props.active ? `${props.theme.colors.primary.main}10` : '#ffffff'};
  border-radius: 6px;
  cursor: pointer;

  .textMenu {
    color: ${props =>
      props.active
        ? props.theme.colors.primary.main
        : props.theme.colors.text.primary} !important;
    font-weight: ${props =>
      props.active
        ? `${props.theme.font.weight.medium} !important`
        : `${props.theme.font.weight.medium} !important`};
    overflow: hidden;
    white-space: nowrap;
  }

  .icon {
    color: ${props =>
      props.active
        ? props.theme.colors.primary.main
        : props.theme.colors.text.primary};
  }

  svg {
    width: 18px;
    height: 18px;
    color: ${props =>
      props.active
        ? props.theme.colors.primary.main
        : props.theme.colors.text.primary};
  }

  position: relative;

  &:hover {
    background: ${props => `${props.theme.colors.primary.main}10`};

    .textMenu {
      color: ${props => props.theme.colors.primary.main} !important;
    }

    .icon,
    svg {
      color: ${props => props.theme.colors.primary.main} !important;
    }
  }
`;

export const WrapperQuantity = styled.div<{
  isToggle?: boolean;
  isDisplay?: boolean;
}>`
  position: absolute;
  ${p =>
    p.isToggle
      ? p.isDisplay
        ? 'right: 10px;'
        : 'display: none;'
      : 'left: 32px; top: 8px;'}
`;

export const CBadge = styled(Badge)`
  .ant-badge-count {
    min-width: 18px !important;
    height: 18px !important;
    padding: 0px 6px;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: ${props => props.theme.font.size.tiny};
    font-weight: ${props => props.theme.font.weight.bold};
  }

  span {
    height: 18px !important;
    line-height: 18px !important;
    font-size: ${props => props.theme.font.size.tiny};
    font-weight: ${props => props.theme.font.weight.bold};
  }
`;
